import React, { ReactElement } from 'react';

import ArrowTriangleDown from '@splunk/react-icons/ArrowTriangleDown';
import Circle from '@splunk/react-icons/Circle';
import Diamond from '@splunk/react-icons/Diamond';
import Triangle from '@splunk/react-icons/Triangle';
import TrianglesLayeredDouble from '@splunk/react-icons/TrianglesLayeredDouble';

import { EventAnnotationIconProps } from '../EventAnnotations';
import { CriticalSeverity, MajorSeverity, MinorSeverity, InfoSeverity, WarningSeverity } from '../constants';

export type AlertIconProps = {
    severity: string | undefined;
    isCleared?: boolean;
} & EventAnnotationIconProps;

export const AlertIcon = (props: AlertIconProps): ReactElement => {
    switch (props.severity) {
        case WarningSeverity:
            return (
                <Diamond
                    width={`${props.dimensions.width}px`}
                    height={`${props.dimensions.width}px`}
                    viewBox="0 0 24 24"
                    style={{ color: props.theme.annotationIcon.alertIconColor.warning }}
                    variant={`${props.isCleared ? 'outlined' : 'filled'}`}
                />
            );
        case InfoSeverity:
            return (
                <Circle
                    width={`${props.dimensions.width}px`}
                    height={`${props.dimensions.width}px`}
                    viewBox="0 0 24 24"
                    style={{ color: props.theme.annotationIcon.alertIconColor.info }}
                    variant={`${props.isCleared ? 'outlined' : 'filled'}`}
                />
            );
        case MinorSeverity:
            return (
                <ArrowTriangleDown
                    width={`${props.dimensions.width}px`}
                    height={`${props.dimensions.width}px`}
                    viewBox="0 0 24 24"
                    style={{ color: props.theme.annotationIcon.alertIconColor.minor }}
                    variant={`${props.isCleared ? 'outlined' : 'filled'}`}
                />
            );
        case MajorSeverity:
            return (
                <Triangle
                    width={`${props.dimensions.width}px`}
                    height={`${props.dimensions.width}px`}
                    viewBox="0 0 24 24"
                    style={{ color: props.theme.annotationIcon.alertIconColor.major }}
                    variant={`${props.isCleared ? 'outlined' : 'filled'}`}
                />
            );
        case CriticalSeverity:
        default:
            return (
                <TrianglesLayeredDouble
                    width={`${props.dimensions.width}px`}
                    height={`${props.dimensions.width}px`}
                    viewBox="0 0 24 24"
                    style={{ color: props.theme.annotationIcon.alertIconColor.critical }}
                    variant={`${props.isCleared ? 'outlined' : 'filled'}`}
                />
            );
    }
};
